<template>
  <div>
    <div>
      <div>
        <div class="account-message">Create a YouPaired Account</div>
        <div>
          <input placeholder="Full Name" type="text"
            v-model="displayName" name="displayName"/>
          <input placeholder="Email" name="email"
            v-model="email" type="text"/>
          <input placeholder="Password"
            v-model="password" name="password" :type="passwordFieldType"/>
          <font-awesome-icon class="eye" :icon="eyeIcon"
            @click="isPasswordVisible = !isPasswordVisible">
          </font-awesome-icon>
          <div>
            <input type="checkbox" name="terms" v-model="termsChecked"/>
            <span>
              I accept the
              <router-link to="/terms" target="_blank">
                Terms
              </router-link>
              ,
              <router-link to="/cookies" target="_blank">
                Cookies
              </router-link>
              and
              <router-link to="/privacy" target="_blank">
                Privacy
              </router-link>
              policies.
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-container" @click="submit">
      Sign Up >
    </div>
    <recaptcha ref="recaptcha" id="sign-up" @verify="submit"></recaptcha>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Recaptcha from '@/components/auth/Recaptcha.vue';

export default {
  name: 'signup-form',
  data() {
    return {
      displayName: '',
      email: '',
      password: '',
      isPasswordVisible: false,
      termsChecked: false,
      isSigningUp: false,
    };
  },
  components: {
    Recaptcha,
  },
  computed: {
    ...mapState('auth', ['backendAxios']),
    passwordFieldType() {
      return this.isPasswordVisible ? 'text' : 'password';
    },
    eyeIcon() {
      return this.isPasswordVisible ? 'eye-slash' : 'eye';
    },
  },
  methods: {
    executeRecaptcha() {
      this.$refs.recaptcha.execute();
    },
    async submit() {
      if (this.isSigningUp) {
        return;
      }
      if (!this.displayName || !this.email || !this.password) {
        this.$toasted.show('Please enter your name, email and password', {
          type: 'info',
          duration: 5000,
        });
        return;
      }
      if (!this.termsChecked) {
        this.$toasted.show('You need to accept the terms, cookies and privacy policies', {
          type: 'info',
          duration: 5000,
        });
        return;
      }
      this.$ga.event('auth', 'local', 'signup', 1);
      try {
        this.isSigningUp = true;
        await this.$store.dispatch('auth/signup', {
          displayName: this.displayName,
          password: this.password,
          email: this.email,
        });
      } catch (err) {
        this.$toasted.show(err.response.data, {
          type: 'info',
          duration: 5000,
        });
      }
      this.isSigningUp = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/youpaired-colors.scss';

input {
  padding: 0.75rem;
  max-width: 20rem;
  width: 90%;
  border-radius: 0.2rem;
  border: 0.05rem solid #DCDBDB;
  -webkit-transition: border-color 0.15s;
  transition: border-color 0.15s;
  font-weight: normal;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0.5rem 0;
  font-size: 0.875rem;
}

input[type="checkbox"] {
  margin: 0.75rem 0;
  cursor: default;
  max-width: 0.75rem;
}

.bottom-container {
  height: 3rem;
  line-height: 3rem;
  width: 100%;
  bottom: 0;
  color: white;
  background-color: $bottom-container;
  font-size: 1.3rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid $bottom-container;
  position: relative;
}

.error-text {
  color: red;
}

.eye {
  cursor: pointer;
  position: relative;
  right: 1.5rem;
  margin-right: -1rem;
}

.account-message {
  font-size:1rem;
  margin: 1rem 0;
}
</style>
